import React, { useEffect, useState, useRef } from "react";
import { withSnackbar } from "notistack";
import { AddCircleOutline as AddIcon, Label } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Chip from "@mui/material/Chip";

import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import TxtRow from "components/Custom/TxtRow";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";
import { COLORS } from "common/colors";

import { GEO_APIs } from "apihandlers/geography";
import { USER_APIs } from "apihandlers/user";
import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { MASTER_APIs } from "apihandlers/master";
import { DateFunctions } from "common/datefunctions";

const PJP = (props: any) => {
  const { setDashMenu } = props;

  const year = new Date().getFullYear();
  const Months = [
    { id: "1", label: "Jan -" + year },
    { id: "2", label: "Feb -" + year },
    { id: "3", label: "Mar -" + year },
    { id: "4", label: "Apr -" + year },
    { id: "5", label: "May -" + year },
    { id: "6", label: "Jun -" + year },
    { id: "7", label: "Jul -" + year },
    { id: "8", label: "Aug -" + year },
    { id: "9", label: "Sep -" + year },
    { id: "10", label: "Oct -" + year },
    { id: "11", label: "Nov -" + year },
    { id: "12", label: "Dec -" + year },
  ];
  const Days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const [assigned, setAssigned] = useState([]);
  const [beat, setBeat] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [days, setDays] = useState(0);
  const [month, setMonth] = useState(0);
  const [rowData, setRowData] = useState({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [reset, setReset] = useState<boolean>(false);
  const [value, setValue] = useState(null);
  const [rows, setRows] = useState({});
  const [activeRow, setActivereRow] = useState();

  const assinedToRef: any = useRef(null);
  const monthRef: any = useRef(null);
  const beatRef: any = useRef(null);

  useEffect(() => {
    getAreas();
  }, []);

  const getAreas = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setBeat(list);
      }
    });
    getUsers();
  };

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setAssigned(list);
      }
    });
  };

  const getRows = (fliterData) => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      assignedDate: fliterData.assignedDate,
      assignedTo: fliterData.assignedTo,
      month: Number(fliterData.month),
    };
    // setRowData({});
    setRows({});
    console.log("getRows", args);
    MASTER_APIs.getPermJourneyPlans(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      let newRowData = {};
      let row = {};
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          const date = new Date(list[i].dateOfBeat).getDate();
          const id = list[i].id;
          row[date] = { id };
          const beatData = JSON.parse(list[i].beatDetails);
          console.log("beatData", beatData);

          newRowData = { ...newRowData };

          beatData.map((items, index) => {
            if (newRowData[date]) {
              newRowData[date].push({ time: items.time, area: items.area });
            } else {
              newRowData[date] = [{ time: items.time, area: items.area }];
            }
          });

          // newRowData[date] = [{ time: beatData.time, area: beatData.area }];
        }
        setRows(row);
        setRowData(newRowData);
        console.log("newRowData", newRowData);

        // setLoading(false);
      }
    });
    console.log("setRowData", rowData);
  };

  const loadData = () => {
    const assignedTo = assinedToRef.current.selectedValue.id;
    const assignedOn = (
      document.getElementById("assignedOn") as HTMLInputElement
    ).value.trim();
    const month = monthRef.current.selectedValue.id;

    setMonth(month);
    let days = new Date(year, month, 0).getDate();
    setDays(days);
    const fliterData = {
      assignedTo,
      assignedDate: assignedOn,
      month,
    };
    let errors = [];
    if (!assignedTo) {
      errors.push({
        id: "assignedTo",
        msg:
          "<span class='bold'>" +
          LABELS.ASSIGNED_TO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!assignedOn) {
      errors.push({
        id: "assignedOn",
        msg:
          "<span class='bold'>" +
          LABELS.ASSIGNED_ON +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!month) {
      errors.push({
        id: "month",
        msg:
          "<span class='bold'>" +
          LABELS.MONTH +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    setLoading(false);
    // setRowData({});
    getRows(fliterData);
  };

  const addData = (id) => {
    const time = (
      document.getElementById("time" + id + "Data") as HTMLInputElement
    ).value.trim();
    const beat =
      beatRef.current.selectedValue && beatRef.current.selectedValue.label;
    setValue(beat);
    if (time && beat) {
      setRowData((rowData) => {
        const newRowData = { ...rowData };
        if (newRowData[id]) {
          newRowData[id].push({ time, area: beat });
        } else {
          newRowData[id] = [{ time, area: beat }];
        }
        return newRowData;
      });
    }
    (document.getElementById("time" + id + "Data") as HTMLInputElement).value =
      null;

    // beatRef.current.clear();
    // setValue((value)=>{
    //   value=roe

    // });
    //  let selectedId = "beat" + id;
    // setSelectedValues([])
    // beatRef.current = { id: null, label: null };
    setReset(true);

    console.log("value", value);
  };
  // setReset(true);

  const onDelete = (day, key) => {
    const filterdData = rowData[day].filter((item, index) => {
      return index != key;
    });
    setRowData((rowData) => ({
      ...rowData,
      [day]: filterdData,
    }));
  };

  const table = () => {
    const tableRows = [];
    for (let i = 1; i <= days; i++) {
      let date = new Date(year, month - 1, i);
      let day = date.getDay();
      const cells = [];
      cells.push(
        <td align={"center"} width={"20%"}>
          <div style={{ padding: "0.5rem" }}>{Days[day]}</div>
          <div style={{ fontSize: "2rem", padding: "0.5rem" }}>
            {i < 10 ? "0" + i : i}
          </div>
        </td>
      );
      cells.push(
        <td id={"row" + i + "Data"} width={"80%"}>
          <div className="flexRow">
            <div className="flexRowAround width30 ">
              <>
                <div className=" width40">
                  <TxtRow
                    id={"time" + i + "Data"}
                    type={"time"}
                    label={"Select Time"}
                  />
                </div>
                <div className=" width40">
                  <label> {"Select Area"}</label>
                  <AutoComplete
                    id={"beat" + i}
                    list={beat}
                    childRef={beatRef}
                    onChange={(e, val) => {
                      // handleDropDownChange(e, val, i);
                      // setValue(val);
                    }}
                    // defaultValue={reset === true ? null : value}
                    inputValue={reset === true ? null : value}
                    // inputValue={
                    //   // selectedValues && selectedValues["beat" + i]
                    //   value
                    // }
                  />
                </div>
              </>

              <div style={{ paddingTop: "1rem" }}>
                <IconButton
                  onClick={() => {
                    addData(i);
                  }}
                >
                  <AddIcon />
                </IconButton>
              </div>
            </div>
            {/* <InputData day={i} /> */}
            <div className="flexRowLeft width80 " style={{ flexWrap: "wrap" }}>
              {Object.keys(rowData).length > 0 &&
                rowData[i] &&
                rowData[i].map((items, key) => {
                  return (
                    <div style={{ padding: "0.2rem" }}>
                      <Chip
                        label={
                          "Time :  " + items.time + "   Area : " + items.area
                        }
                        disabled={false}
                        clickable={false}
                        onDelete={() => {
                          onDelete(i, key);
                        }}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </td>
      );

      tableRows.push(
        <tr style={{ height: "0" }} id={"row" + i}>
          {cells}
        </tr>
      );
    }

    return tableRows;
  };

  const saveRecord = () => {
    const data = Object.keys(rowData).map((items, index) => {
      console.log("Datasss", items);

      return {
        id: (rows[items] && rows[items].id) || -1,
        assignedToId: assinedToRef.current.selectedValue.id,
        assignedDate: (
          document.getElementById("assignedOn") as HTMLInputElement
        ).value.trim(),
        dateOfBeat: (
          year +
          "-" +
          month.toString().padStart(2, "0") +
          "-" +
          items.padStart(2, "0")
        ).toString(),
        activeStatus: true,
        beatDetails: rowData[items],
        assignedById: "",
      };
    });
    const args = {
      journeyPlans: data,
    };
    console.log("journeyPlans", args);
    // return;
    MASTER_APIs.managePermJourneyPlan(args).then((res) => {
      // setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        // setSelectedRow({});
        // setManageDialog(false);
        // reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("GET DATA", rows);

  beatRef.current = { id: null, label: null };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.PJP}</li>
        </ul>
        <h4>{TITLES.PJP}</h4>
        <p>{SUB_TITLES.PJP}</p>
      </div>

      <div>
        <div className=" flexRowJustify width70">
          <div className="formGroup width25 required">
            <label>{LABELS.ASSIGNED_TO}</label>
            <span className="red">{" *"}</span>
            <AutoComplete
              id={"assignedTo"}
              list={assigned}
              childRef={assinedToRef}
            />
          </div>

          <div className="formGroup width25 required">
            <TxtRow
              id={"assignedOn"}
              type={"date"}
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                FORMATS.SQL_DATE_ONLY
              )}
              label={LABELS.ASSIGNED_ON}
            />
          </div>
          <div className="formGroup width25 required ">
            <label>{LABELS.MONTH}</label>
            <span className="red">{" *"}</span>

            <AutoComplete
              id={"month"}
              list={Months}
              childRef={monthRef}
              onChange={() => {
                setLoading(true);
              }}
            />
          </div>
          <div
            style={{
              padding: "1.5rem 0rem 3rem 0rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadData}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>

        {mandatoryResults.length > 0 ? (
          <div className="mandatoryBox" style={{ marginRight: "1rem" }}>
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          !loading && (
            <div>
              <div
                style={{
                  height: "45rem",
                  width: "95%",
                  overflowY: "scroll",
                  background: activeRow ? "#ccccd3" : "ghostWhite",
                }}
              >
                <table border={1} cellSpacing={0} width={"100%"}>
                  <tbody>{table()}</tbody>
                </table>
              </div>

              <div
                className="formGroup submitBtnWrapper"
                style={{ width: "95%" }}
              >
                <div className="flexbtnjustify">
                  <Btn
                    text={LABELS.SAVE}
                    // loading={isSubmit}
                    onClick={saveRecord}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(PJP);
